import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { GenericSkeletonComponent, PegaMobielModule } from '@ap/pega';

import { BaseStarterAppModule } from '../base-starter-app/base-starter-app.module';

import { StarterAppMobielComponent } from './starter-app-mobiel.component';

@NgModule({
    imports: [
        BaseStarterAppModule,
        GenericSkeletonComponent,
        PegaMobielModule,
        RouterModule.forRoot([], {
            useHash: false,
            enableTracing: false
        })
    ],
    declarations: [StarterAppMobielComponent],
    exports: [BaseStarterAppModule, PegaMobielModule, StarterAppMobielComponent],
    bootstrap: [StarterAppMobielComponent]
})
export class StarterAppMobielModule {}
